import { Overlay } from '@/components/atoms/Overlay';
import { Fragment, ReactNode } from 'react';
import * as S from './styles';
import Heading from '@/components/atoms/Heading';
import Text from '@/components/atoms/Text';
import Button, { ButtonColor } from '@/components/atoms/Button';
import { usePageScrollAreaHook } from '@/components/organisms/PageScrollArea/hook/usePageScrollAreaHook';
import { CSSProperties } from 'styled-components';

export type AlertDialogSize = 1 | 2 | 3;

interface AlertDialogProps {
  $size: AlertDialogSize;
  $visivel: boolean;
  $titulo: string;
  $descricao: string | ReactNode;
  $Slot?: ReactNode;
  $contentContainerStyle?: CSSProperties;
  $textoBotaoCancelar: string;
  $textoBotaoAcao: string;
  $cancelarBotaoFuncao: () => void;
  $acaoBotaoFuncao: () => void;
  $esconderBotaoCancelar?: boolean;
  $esconderBotaoAcao?: boolean;
  $colorBotaoAcao?: ButtonColor;
  $loadingBotaoAcao?: boolean;
  style?: CSSProperties;
}

export default function AlertDialog(props: AlertDialogProps) {
  const {
    $visivel,
    $titulo,
    $descricao,
    $Slot,
    $contentContainerStyle,
    $textoBotaoCancelar,
    $textoBotaoAcao,
    $cancelarBotaoFuncao,
    $acaoBotaoFuncao,
    $size,
    $colorBotaoAcao,
    $loadingBotaoAcao = false,
    $esconderBotaoCancelar = false,
    $esconderBotaoAcao = false,
    style,
  } = props;

  const tamanhoTitulo = $size > 1 ? 5 : 1;
  const tamanhoDemaisComponentes = $size > 1 ? 2 : 1;

  const { retornarValorMargemTopo } = usePageScrollAreaHook({
    isPageScrollArea: false,
  });

  if (!$visivel) return null;

  return (
    <Fragment>
      <button style={{ background: 'none' }} onClick={$cancelarBotaoFuncao}>
        <Overlay
          $distanciaTopo={retornarValorMargemTopo('home')}
          $valorSobreposicaoDosDemaisComponentes={995}
        />
      </button>
      <S.ContainerDialog id={'alertDialogContainer'} style={style}>
        <S.ContainerTextoDialog>
          <Heading
            $priority={5}
            $size={tamanhoTitulo}
            $color="neutral"
            $weight="bold"
            $align="left"
            $highContrast={true}
            $text={$titulo}
          />
          <Text
            $size={tamanhoDemaisComponentes}
            $color="neutral"
            $weight="regular"
            $align="left"
            $highContrast={true}
            $text={$descricao}
          />
        </S.ContainerTextoDialog>
        {$Slot ? <div style={$contentContainerStyle}>{$Slot}</div> : null}
        <S.ContainerButtonsDialog>
          {$esconderBotaoCancelar ? null : (
            <Button
              $size={tamanhoDemaisComponentes}
              $variant="soft"
              $color="neutral"
              $highContrast={false}
              $loading={false}
              $focusRing={false}
              $text={$textoBotaoCancelar}
              $onClick={$cancelarBotaoFuncao}
            />
          )}
          {$esconderBotaoAcao ? null : (
            <Button
              $size={tamanhoDemaisComponentes}
              $variant="solid"
              $color={$colorBotaoAcao || 'accent'}
              $highContrast={false}
              $loading={$loadingBotaoAcao}
              $focusRing={false}
              $text={$textoBotaoAcao}
              $onClick={$acaoBotaoFuncao}
            />
          )}
        </S.ContainerButtonsDialog>
      </S.ContainerDialog>
    </Fragment>
  );
}
